export default __webpack_public_path__ + "static/media/tag_goodnight_ko.bace9969.gif";